module.exports = __webpack_public_path__ + "img/bar-chart-2.6c44238f.svg";